import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import Logo from '../../../svg/Logo';
import './nav.css'
import '../../../App.css'
import NavBtn from '../../../svg/website/mobile/NavBtn'
import NavBtn_ from '../../../svg/website/mobile/NavBtn_'
import NavDeca1 from '../../../svg/website/mobile/NavDeca1'
import NavDeca2 from '../../../svg/website/mobile/NavDeca2'
function Screen({ isExspand, setIsExspand }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [curScreen, setCurScreen] = useState('/')

    useEffect(() => {
        const pathName = location.pathname.split('/')[1]
        setCurScreen(`/${pathName}`)
    }, [location])
    const navigateTo = (str) => () => {
        setIsExspand(false)
        navigate(str)

    }

    const [windowSize, setWindowSize] = useState(getWindowSize());
    function getWindowSize() { const { innerWidth, innerHeight } = window; return { innerWidth, innerHeight }; }
    useEffect(() => {
        function handleWindowResize() { setWindowSize(getWindowSize()); }
        window.addEventListener('resize', handleWindowResize);
        return () => { window.removeEventListener('resize', handleWindowResize); };
    }, [])

    const openNewTab = (url) => () => {
        window
            .open(url, '_blank')
            .focus();
    }



    const [isShowMoblieMenu, setisShowMoblieMenu] = useState(false)
    return (
        <div id='navbar'>
            <div className='relative text-white flex justify-start items-stretch flex-row w-full text-[12px] bg-main d-flex-m-hidden'>
                <div className='h-full relative text-white flex justify-between flex-row w-full nav_padding items-center' style={{ overflowX: 'auto', gap: 24 }}>
                    <div className='cursor-pointer' onClick={() => { navigate('/') }}><Logo /></div>
                    {/*desktop menu*/}
                    <div className='flex flex-row flex-wrap items-center text-[#717171] font-[500] nav_text z-[1]' >
                        <div onClick={navigateTo('/')} style={{ color: ['/', '/home', '/index.html'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            主頁
                        </div>
                        <div onClick={navigateTo('/#aboutus')} style={{ color: ['/aboutus'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            關於我們
                        </div>
                        <div onClick={navigateTo('/details')} style={{ color: ['/details'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            參與計劃的好處
                        </div>
                        <div onClick={navigateTo('/register')} style={{ color: ['/register'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            學校登記
                        </div>
                        <div onClick={navigateTo('/#contactus')} style={{ color: ['/contactus'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            聯絡我們
                        </div>
                        {/* <a href='/#contactus' onClick={() => navigateTo(`/#contactus`)} style={{color:['/contactus'].includes(curScreen)?'#425596':'#000000'}} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">聯絡我們</a> */}
                        <div onClick={navigateTo('/platform')} style={{ color: ['/platform'].includes(curScreen) ? '#425596' : '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            登入
                        </div>
                    </div>

                </div>
            </div>
            <div className='relative text-white flex justify-start items-stretch flex-row w-full text-[12px] bg-main d-hidden-m-flex'>
                <div className='h-full relative text-white flex justify-between flex-row w-full nav_padding items-center' style={{ overflowX: 'auto', gap: 24 }}>
                    <div className='w-[20%] min-w-[200px]'>
                        <Logo width='100%' />
                    </div>

                    {/*desktop menu*/}
                    <div className='flex flex-row flex-wrap items-center text-[#717171] font-[500] nav_text z-[1]' onClick={() => setIsExspand(!isExspand)}>
                        {!isExspand ? <NavBtn /> : <NavBtn_ />}
                    </div>

                </div>
            </div>
            {isExspand && <div className='fixed inset-0 w-full h-full bg-main d-hidden-m-flex flex flex-col' style={{ zIndex: 9999 }}>
                <div id='navbar' className='relative top-0 text-white flex justify-start items-stretch flex-col w-full text-[12px] d-hidden-m-flex'>
                    <div className='relative text-white flex justify-end flex-row w-full nav_padding items-center mt-[3px]' style={{ overflowX: 'auto', gap: 24 }}>
                        <div className='flex flex-row flex-wrap items-center text-[#717171] font-[500] z-[1]' onClick={() => setIsExspand(!isExspand)}>
                            <NavBtn_ />
                        </div>
                    </div>
                </div>
                <div className='w-full h-full flex flex-row items-center justify-center absolute top-0'>
                    <div className='absolute top-[5%] flex flex-row items-start justify-start w-full'>
                        <NavDeca1 />
                    </div>
                    <div className='w-full h-[70%] bg-[#c2f3e7]'>
                        
                    </div>
                    <div className='absolute bottom-[5%] flex flex-row items-start justify-end w-full'>
                        <NavDeca2 />
                    </div>
                </div>
                <div className='flex flex-row w-full justify-center font-bold flex-wrap items-center text-[#717171] font-[300] text-[12px] z-[1] gap-[32px] mt-[32px] absolute bottom-[2%]'>
                    <div onClick={navigateTo('/')} style={{ color: '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                        © 網讀無界
                    </div>
                    <div onClick={openNewTab('https://hku.hk/about/policies_reports/c_privacy_policy.html')} style={{ color: '#000000' }} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center">
                        隱私權政策
                    </div>
                </div>
                <div className='flex flex-col items-center justify-center w-full h-full absolute top-0 left-0 z-[1]'>
                    <div className='flex flex-col items-evenly justify-around h-[70%] flex-wrap text-[#717171] font-[500] text-[16px] z-[1] py-[15%] ' >
                        <div onClick={navigateTo('/')} style={{ color: ['/', '/home', '/index.html'].includes(curScreen) ? '#425596' : '#000000' }} className="dash_under relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            主頁
                        </div>
                        <div onClick={navigateTo('/#aboutus')} style={{ color: ['/aboutus'].includes(curScreen) ? '#425596' : '#000000' }} className="dash_under relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            關於我們
                        </div>
                        <div onClick={navigateTo('/details')} style={{ color: ['/details'].includes(curScreen) ? '#425596' : '#000000' }} className="dash_under relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            參與計劃的好處
                        </div>
                        <div onClick={navigateTo('/register')} style={{ color: ['/register'].includes(curScreen) ? '#425596' : '#000000' }} className="dash_under relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            學校登記
                        </div>
                        <div onClick={navigateTo('/#contactus')} style={{ color: ['/contactus'].includes(curScreen) ? '#425596' : '#000000' }} className="dash_under relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            聯絡我們
                        </div>
                        {/* <a href='/#contactus' onClick={() => navigateTo(`/#contactus`)} style={{color:['/contactus'].includes(curScreen)?'#425596':'#000000'}} className="relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">聯絡我們</a> */}
                        <div onClick={navigateTo('/platform')} style={{ color: ['/platform'].includes(curScreen) ? '#425596' : '#000000' }} className="dash_under relative flex items-center justify-center hover:font-bold cursor-pointer text-center px-[14px]">
                            登入
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Screen)